import _Set from 'babel-runtime/core-js/set';
import _Array$from from 'babel-runtime/core-js/array/from';
import _Promise from 'babel-runtime/core-js/promise';
import { filedValidatesAPI } from '@/api/crm/common';

import { isArray, isEmpty, isObject } from '@/utils/types';
import { objDeepCopy } from '@/utils';
import GenerateRulesMixin from '@/components/NewCom/WkForm/GenerateRules';
import moment from 'moment';
export default {
  mixins: [GenerateRulesMixin],

  props: {},

  methods: {
    /**
     * 获取初始value值
     * detail 主要用于关联模块
     * type update 读取 value 判断 save 读取 default_value 判断
     */
    getItemValue: function getItemValue(item, detail, type) {
      var _this = this;

      detail = detail || {};
      if (item.form_type == 'contacts' || item.form_type == 'customer' || item.form_type == 'contract' || item.form_type == 'business') {
        // crm相关信息特殊处理
        if (type === 'update') {
          return item.value ? objDeepCopy(item.value) : [];
        } else {
          var relativeData = detail[item.form_type];
          return relativeData ? [relativeData] : [];
        }
      } else if (item.form_type == 'category' || item.form_type == 'category') {
        // 产品类别
        return item.value ? item.value.map(function (item) {
          return parseInt(item);
        }) : [];
        // return item.value ? item.value : ''
      } else if (item.form_type == 'product' || item.form_type == 'product') {
        // 关联产品
        return item.value;
      } else if (item.form_type == 'map_address' || item.form_type == 'map_address') {
        if (type == 'update') {
          if (item.value.address) {
            item.value.address = item.value.address.length == 0 ? '' : item.value.address;
          }
          return item.value;
        } else {
          return {};
        }
      } else if (item.form_type == 'single_user') {
        if (type === 'update') {
          return isObject(item.value) && item.value.id ? item.value.id : '';
        } else {
          return isObject(item.default_value) && item.default_value.id ? objDeepCopy(item.default_value.id) : '';
        }
      } else if (item.form_type == 'user' || item.form_type == 'structure' || item.form_type == 'file') {
        if (type === 'update') {
          return item.value ? objDeepCopy(item.value) : [];
        } else {
          return item.default_value && !!item.default_value ? objDeepCopy(item.default_value) : [];
        }
      } else {
        if (item.form_type == 'number' || item.form_type == 'floatnumber' || item.form_type == 'percent') {
          if (type == 'update') {
            return isEmpty(item.value) ? undefined : item.value;
          } else {
            return isEmpty(item.default_value) ? undefined : item.default_value;
          }
        } else if (item.form_type == 'detail_table' || item.form_type == 'detail_table') {
          var baseFieldList = item.value || [item.fieldExtendList];
          // 二维数组
          var tableValue = [];
          baseFieldList.forEach(function (bigItem) {
            var subForm = {};
            tableValue.push(subForm);
            bigItem.forEach(function (subItem) {
              // 未转换 取 field 值
              if (['select', 'checkbox'].includes(subItem.form_type)) {
                subItem.optionsData = null;
              }
              subForm[subItem.field] = _this.getItemValue(subItem, null, type);
            });
          });
          return tableValue;
        } else {
          if (type == 'update') {
            return item.value || '';
          } else {
            return item.default_value || '';
          }
        }
      }
    },


    /**
     * 验证唯一
     */
    getUniquePromise: function getUniquePromise(field, value, detail) {
      var _this2 = this;

      return new _Promise(function (resolve, reject) {
        // var validatesParams = {}
        // validatesParams.field_id = field.field_id
        // if (isArray(value)) {
        //   let postValue = ''
        //   if (value.length > 0) {
        //     if (
        //       field.form_type == 'user' ||
        //           field.form_type == 'structure'
        //     ) {
        //       postValue = value
        //         .map(valueItem => {
        //           return field.form_type == 'user'
        //             ? valueItem.userId
        //             : valueItem.id
        //         })
        //         .join(',')
        //     } else if (field.field == 'categoryId') {
        //       if (value && value.length) {
        //         postValue = value[value.length - 1]
        //       } else {
        //         postValue = ''
        //       }
        //     } else if (field.form_type == 'checkbox') {
        //       postValue = value.join(',')
        //     }
        //   }
        //   validatesParams.val = postValue
        // } else {
        //   validatesParams.val = value
        //   validatesParams.types = field.types
        //   validatesParams.field = field.field
        // }
        // if (detail.type == 'update') {
        //   validatesParams.id = detail.action_id || detail.id
        // }
        var validatesParams = {};
        validatesParams.field_id = field.field_id;
        validatesParams.val = _this2.getRealParams(field, value);
        validatesParams.types = field.types;
        validatesParams.field = field.field;
        if (detail.type == 'update') {
          validatesParams.id = detail.action_id || detail.id;
        }
        filedValidatesAPI(validatesParams).then(function (res) {
          // status 1 通过 0
          var resData = res || {};
          if (res.code === 200) {
            resolve();
          } else {
            if (resData.ownerUserName) {
              reject(field.name + '\u5DF2\u5B58\u5728\uFF0C\u8D1F\u8D23\u4EBA\u4E3A\u201C' + resData.ownerUserName + '\u201D');
            } else if (resData.poolNames && resData.poolNames.length > 0) {
              reject(field.name + '\u5DF2\u5B58\u5728\uFF0C\u5F53\u524D\u4F4D\u4E8E\u516C\u6D77\u201C' + resData.poolNames.join('，') + '\u201D');
            } else {
              reject(field.name + '\u5DF2\u5B58\u5728');
            }
          }
        }).catch(function () {
          reject(field.name + '\u5DF2\u5B58\u5728');
        });
      });
    },

    /**
     * 获取字段默认内容
     */
    getFormItemDefaultProperty: function getFormItemDefaultProperty(item) {
      var _this3 = this;

      var isCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var temp = isCopy ? objDeepCopy(item) : item;
      temp.field = item.field;
      temp.field = item.field;

      // 细化 precisions
      if ((item.form_type || item.form_type) === 'date_interval') {
        // 1 日期  2 时间日期
        if (item.precisions === 2) {
          temp.dateType = 'datetimerange';
          temp.dateValueFormat = 'yyyy-MM-dd HH:mm:ss';
        } else {
          temp.dateType = 'daterange';
          temp.dateValueFormat = 'yyyy-MM-dd';
        }
      } else if ((item.form_type || item.form_type) === 'position') {
        // 1 省/地区、市、区/县、详细地址 2 省/地区、市、区/县
        // 3 省/地区、市 4 省/地区
        temp.showDetail = item.precisions === 1;
        temp.hideArea = item.precisions === 3 || item.precisions === 4;
        temp.onlyProvince = item.precisions === 4;
      } else if ((item.form_type || item.form_type) === 'detail_table') {
        // 校准默认单元数据
        // authLevel 1 不能查看不能编辑 2可查看  3 可编辑可查看
        var fieldForm = {};
        temp.fieldExtendList.forEach(function (extendItem) {
          var copyExtendItem = objDeepCopy(extendItem);
          _this3.getFormItemDefaultProperty(extendItem, false);
          extendItem.show = extendItem.is_hidden !== 1;
          if (extendItem.show) {
            extendItem.rules = _this3.getRules(copyExtendItem);
          }
          _this3.getItemRadio(extendItem, extendItem);
          fieldForm[extendItem.field] = _this3.getItemValue(extendItem);
        });
        temp.fieldForm = fieldForm; // 用于追加新事项

        var fieldExtendList = objDeepCopy(item.fieldExtendList);
        var baseFieldList = isEmpty(item.value) ? [fieldExtendList] : item.value;
        // 二维数组
        var tableFieldList = [];
        baseFieldList.forEach(function (bigItem) {
          var subValue = [];
          bigItem.forEach(function (subItem) {
            var copySubItem = objDeepCopy(subItem);
            var subTemp = _this3.getFormItemDefaultProperty(subItem, false);
            // 特殊字段允许多选
            _this3.getItemRadio(subItem, subTemp);
            subTemp.show = subTemp.is_hidden !== 1;
            if (subTemp.show) {
              subTemp.rules = _this3.getRules(copySubItem);
            }
            subValue.push(subTemp);
          });
          tableFieldList.push(subValue);
        });
        temp.fieldList = tableFieldList;
      }
      return temp;
    },


    /**
     * 获取二维数组字段
     * @param {*} array
     * @param {*} form_type
     */
    getItemWithFromType: function getItemWithFromType(array, form_type) {
      var item = null;
      for (var index = 0; index < array.length; index++) {
        var children = array[index];
        for (var childIndex = 0; childIndex < children.length; childIndex++) {
          var element = children[childIndex];
          if (element.form_type === form_type) {
            item = element;
            break;
          }
        }

        if (item) {
          break;
        }
      }

      return item;
    },


    /**
     * 循环二维数组
     * @param {*} array
     * @param {*} result
     */
    itemsForEach: function itemsForEach(array, callback) {
      for (var index = 0; index < array.length; index++) {
        var children = array[index];
        for (var childIndex = 0; childIndex < children.length; childIndex++) {
          var element = children[childIndex];
          callback(element, index, childIndex, children);
        }
      }
    },

    /**
     * 获取字段是否可编辑
     */
    getItemIsCanEdit: function getItemIsCanEdit(item, type) {
      // authLevel 1 不能查看不能编辑 2可查看  3 可编辑可查看
      // return (type === 'update' && item.authLevel == 3) || type !== 'update'
      // return (type === 'update' && item.writeStatus === 1) || type !== 'update'
      return item.writeStatus === 1;
    },


    /**
     * user single_user structure
     */
    getItemRadio: function getItemRadio(field, data) {
      if (field.form_type == 'single_user') {
        data.radio = true;
      } else if (field.form_type == 'user' || field.form_type == 'structure' || field.form_type == 'user' || field.form_type == 'structure') {
        data.radio = false;
      }
    },


    /**
     * 获取error错误
     */
    getFormErrorMessage: function getFormErrorMessage(crmForm) {
      // 提示第一个error
      if (crmForm.fields) {
        for (var index = 0; index < crmForm.fields.length; index++) {
          var ruleField = crmForm.fields[index];
          if (ruleField.validateState == 'error') {
            this.$message.error(ruleField.validateMessage);
            break;
          }
        }
      }
    },


    /**
     * 获取相关联item
     */
    getItemRelatveInfo: function getItemRelatveInfo(list, fromType) {
      var crmItem = null;
      if (this.action.type == 'relative') {
        crmItem = this.action.data[fromType];
      } else {
        var childIsArray = list.length > 0 && isArray(list[0]);
        var crmObj = childIsArray ? this.getItemWithFromType(list, fromType) : list.find(function (listItem) {
          return listItem.form_type === fromType;
        });
        if (crmObj && crmObj.value && crmObj.value.length > 0) {
          crmItem = crmObj.value[0];
        }
      }
      return crmItem;
    },


    /**
     * 获取提交参数
     */
    getSubmiteParams: function getSubmiteParams(array, data) {
      // var params = { address: [] }
      var params = {};
      for (var index = 0; index < array.length; index++) {
        var field = array[index];
        var dataValue = null;
        if (field.hasOwnProperty('show')) {
          dataValue = field.show ? data[field.field] : null;
        } else {
          dataValue = data[field.field];
        }
        if (field.form_type == 'product') {
          this.getProductParams(params, dataValue);
        } else if (field.form_type == 'map_address') {
          this.getCustomerAddressParams(params, dataValue);
        } else if (field.field_type == 1) {
          var fieldValue = this.getRealParams(field, dataValue);
          params[field.field] = isEmpty(fieldValue) ? '' : fieldValue;
        } else if (field.form_type !== 'desc_text') {
          //  描述文字忽略
          field.value = this.getRealParams(field, dataValue, data);
          params[field.field] = field.value;
          // params.field.push({
          //   field: field.field,
          //   field_type: field.field_type,
          //   name: field.name,
          //   type: field.type,
          //   field_id: field.field_id,
          //   value: this.getRealParams(field, dataValue)
          // })
        }
        //  else {
        //   field.value = this.getRealParams(field, dataValue, data)
        //   params[field.field] = field.value
        // }
      }
      return params;
    },


    /**
     * 获取产品提交参数
     */
    getProductParams: function getProductParams(params, dataValue) {
      if (dataValue) {
        params['product'] = dataValue.product ? dataValue.product.map(function (item) {
          item.sales_price = item.sales_price == '' ? 0 : item.sales_price;
          item.num = item.num == '' ? 0 : item.num;
          item.discount = item.discount == '' ? 0 : item.discount;
          item.product_id = item.product_id || '';
          item.category_id_info = item.categoryName || '默认';
          return item;
        }) : [];
        params['total_price'] = dataValue.total_price ? dataValue.total_price : 0;
        params['discount_rate'] = dataValue.discount_rate ? dataValue.discount_rate : 0;
      } else {
        params['product'] = [];
        params['total_price'] = '';
        params['discount_rate'] = '';
      }
    },


    /**
     * 获取客户位置提交参数
     */
    getCustomerAddressParams: function getCustomerAddressParams(params, dataValue) {
      params['address'] = dataValue.address && dataValue.address.filter(function (item) {
        return item;
      }).length > 0 ? dataValue.address : '';
      params['detail_address'] = dataValue.detail_address;
      params['location'] = dataValue.location;
      params['lng'] = dataValue.lng;
      params['lat'] = dataValue.lat;
    },


    /**
     * 关联客户 联系人等数据要特殊处理
     */
    getRealParams: function getRealParams(field, dataValue, data) {
      var _this4 = this;

      if (field.field == 'customer_id' || field.field == 'contacts_id' || field.field == 'business_id' || field.field == 'leads_id' || field.field == 'contract_id') {
        if (dataValue && dataValue.length) {
          return dataValue[0][field.field];
        } else {
          return '';
        }
      } else if (field.form_type == 'user' || field.form_type == 'structure') {
        return dataValue ? dataValue.join(',') : '';
      } else if (field.form_type == 'file') {
        if (dataValue && dataValue.length > 0) {
          return dataValue.map(function (item) {
            return item.file_id;
          });
        }
        return [];
      } else if (field.form_type == 'category') {
        if (dataValue && dataValue.length > 0) {
          return dataValue[dataValue.length - 1];
        }
        return '';
      } else if (field.form_type == 'checkbox') {
        // if (isArray(dataValue)) {
        //   return dataValue.join(',')
        // }
        return dataValue;
      } else if (field.form_type == 'date') {
        if (dataValue) {
          return dataValue;
        }
        // delete data[field.field]
        return '';
      } else if (field.form_type == 'datetime') {
        if (dataValue) {
          return moment(dataValue).unix();
        }
        // delete data[field.field]
        return '';
      } else if (field.form_type == 'number') {
        if (dataValue) {
          return dataValue;
        }
        return '';
      } else if (field.form_type == 'detail_table') {
        var fieldExtendList = field.fieldExtendList || [];
        var values = [];
        var tableValues = Array.isArray(dataValue) ? dataValue : [];

        var _loop = function _loop(tableValueIndex) {
          var tableValue = tableValues[tableValueIndex];
          // 去除空值数据
          if (!_this4.getFormValueIsEmpty(fieldExtendList, tableValue)) {
            var valuesItems = [];
            fieldExtendList.forEach(function (tableField) {
              var copyTableField = objDeepCopy(tableField);
              delete copyTableField.companyId;
              copyTableField.value = _this4.getRealParams(copyTableField, tableValue[copyTableField.field]);
              valuesItems.push(copyTableField);
            });
            values.push(valuesItems);
          }
        };

        for (var tableValueIndex = 0; tableValueIndex < tableValues.length; tableValueIndex++) {
          _loop(tableValueIndex);
        }

        return values;
      }

      return dataValue;
    },

    /**
     * 判断对象值是否是空
     */
    getFormValueIsEmpty: function getFormValueIsEmpty(fieldList, valueObj) {
      for (var index = 0; index < fieldList.length; index++) {
        var field = fieldList[index];
        var value = valueObj[field.field];
        // if (field.form_type === 'select' || field.form_type === 'checkbox') {
        //   if (isObject(value) && !isEmpty(value.select)) {
        //     return false
        //   }
        // } else if (field.form_type === 'location') {
        if (field.form_type === 'location') {
          if (isObject(value) && (!isEmpty(value.lat) || !isEmpty(value.lng) || !isEmpty(value.address))) {
            return false;
          }
        } else if (!isEmpty(value)) {
          return false;
        }
      }
      return true;
    },

    /**
     * 获取逻辑表单隐藏id
     */
    getFormAssistIds: function getFormAssistIds(list, valueObj) {
      var allIds = [];
      list.forEach(function (items) {
        items.forEach(function (item) {
          if (['select', 'checkbox'].includes(item.form_type || item.form_type) && item.remark === 'options_type' && item.optionsData) {
            for (var key in item.optionsData) {
              allIds = allIds.concat(item.optionsData[key] || []);
            }
          }
        });
      });

      allIds = allIds.filter(function (o) {
        return Boolean(o);
      });
      allIds = _Array$from(new _Set(allIds));

      var ignoreIds = [];
      this.getFormAssistData(list, valueObj, allIds, ignoreIds);
      return allIds.filter(function (o) {
        return !ignoreIds.includes(o);
      });
    },


    /**
     * 获取信息
     */
    getFormAssistData: function getFormAssistData(list, valueObj, allIds, ignoreIds) {
      // let ignorIds = []
      var ignoreLength = ignoreIds.length;
      list.forEach(function (items) {
        items.forEach(function (item) {
          if (['select', 'checkbox'].includes(item.form_type || item.form_type) && item.remark === 'options_type' && item.optionsData) {
            var value = valueObj ? valueObj[item.field || item.field] : item.value;
            if (!allIds.includes(item.formAssistId)) {
              if ((item.form_type || item.form_type) === 'select') {
                if (isEmpty(value)) {
                  value = [];
                } else {
                  value = item.setting.includes(value) ? [value] : ['其他'];
                }
              } else if ((item.form_type || item.form_type) === 'checkbox') {
                if (isArray(value)) {
                  var copyValue = objDeepCopy(value);
                  var otherItem = copyValue.filter(function (name) {
                    return !item.setting.includes(name);
                  });
                  if (otherItem.length > 0) {
                    var newValue = copyValue.filter(function (name) {
                      return !otherItem.includes(name);
                    });
                    newValue.push('其他');
                    value = newValue;
                  }
                } else {
                  value = [];
                }
              }

              for (var key in item.optionsData) {
                if (value && value.includes(key)) {
                  var keyValue = item.optionsData[key] || [];
                  for (var index = 0; index < keyValue.length; index++) {
                    var id = keyValue[index];
                    if (!ignoreIds.includes(id)) {
                      ignoreIds.push(id);
                    }
                  }
                }
              }
            }
          }
        });
      });

      if (ignoreLength !== ignoreIds.length) {
        var newAllIds = allIds.filter(function (o) {
          return !ignoreIds.includes(o);
        });
        this.getFormAssistData(list, valueObj, newAllIds, ignoreIds);
      }
    },


    /**
     * 获取表单展示内容
     * data 用于相关模块新建填充模块值
     * type 新建编辑
     */
    getFormContentByOptionsChange: function getFormContentByOptionsChange(fieldList, formObj) {
      var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _this5 = this;

      var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var type = arguments[4];

      var allFieldRules = this.fieldRules || rules;
      var actionData = this.action && this.action.data ? this.action.data : data;
      var actionType = this.action && this.action.type ? this.action.type : type;

      var fieldRules = {};
      var fieldForm = {};

      // 依据最新的值，获取隐藏的ids
      var assistIds = this.getFormAssistIds(fieldList, formObj);
      this.itemsForEach(fieldList, function (fieldItem) {
        fieldItem.show = !assistIds.includes(fieldItem.formAssistId);
        // 展示 并且 允许编辑，加入验证规则
        if (fieldItem.show && !fieldItem.disabled) {
          if (allFieldRules[fieldItem.field]) {
            fieldRules[fieldItem.field] = allFieldRules[fieldItem.field];
          } else {
            fieldRules[fieldItem.field] = _this5.getRules(fieldItem);
          }
        }

        // 值获取
        if (fieldItem.show) {
          if (formObj[fieldItem.field]) {
            fieldForm[fieldItem.field] = formObj[fieldItem.field];
          } else {
            fieldForm[fieldItem.field] = _this5.getItemValue(fieldItem, actionData, actionType);
          }
        }
      });

      return {
        fieldForm: fieldForm,
        fieldRules: fieldRules
      };
    }
  }
};